import { createContext } from 'react';

export const ActionsInputContext = createContext({});
export const ActionsInputContextProvider = ActionsInputContext.Provider;
